import { getApiByWithoutId, postApiPagination } from "../../../Shared/Services/RestService";
import { TalentIntelligenceDashboard, TalentSearchResponse } from "../Types/TalentIntelligenceTypes";

export const searchTalentIntelligence = (
  filters: Record<string, unknown>,
  page: number = 0,
  size?: number
) => {
  const params: Record<string, unknown> = { page };
  if (size !== undefined) params.size = size;
  return postApiPagination<TalentSearchResponse>(
    "/recruiter/intelligence/search",
    { filters },
    params
  );
};

export const getTalentIntelligenceDashboard = () => {
  return getApiByWithoutId<TalentIntelligenceDashboard>("/recruiter/intelligence/dashboard");
};